<template>
  <div class="card">
    <div class="card-body">
      <b-table
        class="datatables"
        responsive="sm"
        :fields="fields" 
        :current-page="currentPage"
        per-page="10"
        :items="items"

        bordered
        striped
      >
        <template #cell(interacao)="data">
          <div v-if="data.item.ST_PROJETO === 'COMPLETO' || data.item.ST_PROJETO === 'EXPORTADO'">
            <b-button size="sm" variant="primary" class="me-1" :disabled="loadingAcoes" data-tooltip="Visualizar" data-tooltip-location="left" @click="emitirEditarItem(data.item)">
              <i class="mdi mdi-eye"></i>
            </b-button>
          </div>
          <div class="d-flex justify-content-start" v-else>
            <b-button size="sm" variant="primary" class="me-1" :disabled="loadingAcoes" data-tooltip="Editar" data-tooltip-location="left" @click="emitirEditarItem(data.item)">
            <i class="mdi mdi-pencil"></i>
            </b-button>
            <b-button size="sm" variant="danger" data-tooltip="Excluir" :disabled="loadingAcoes" data-tooltip-location="left" @click="deletarProjeto(data.item)">
              <i class="mdi mdi-trash-can"></i>
              <b-spinner
                variant="primary"
                small
                class="ms-2"
                v-if="loadingAcoes"
              ></b-spinner>
            </b-button>
          </div>
        </template>
      </b-table>
      <div class="d-flex justify-content-end mt-3">
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="itemsPerPage"
          class="pagination pagination-rounded mb-0" />
      </div>
    </div>
  </div>
</template>

<script>
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";

export default {
  mixins: [clienteRuralMixin],
  name: 'Grid',
  props: {
    filtro: {
      type: Object,
      default: () => ({})
    },
    items: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      sortField: '',
      sortOrder: '',
      loadingAcoes: false,
      fields: [
        { key: 'ST_PROJETO', label: 'Status', sortable: true },
        { key: 'nr_plano', label: 'Nº Projeto', sortable: true },
        { key: 'sq_produtor', label: 'Cliente Rural ', sortable: true },
        { key: 'sq_produtor2', label: 'CPF/CNPJ', sortable: true },
        { key: 'sq_linha_credito', label: 'Linha de Crédito', sortable: true },
        { key: 'sq_modalidade_seguro', label: 'Modalidade de Seguro', sortable: true },
        { key: 'cd_safra', label: 'Safra', sortable: true },
        { key: 'astec', label: 'ASTEC Financiada', sortable: true },
        { key: 'vl_orcado', label: 'Valor Orçado', sortable: true },
        { key: 'vl_astec', label: 'Valor Astec', sortable: true },
        { key: 'qt_area', label: 'Area/há', sortable: true },
        { key: 'interacao', label: '' }
      ],
    };
  },
  computed: {
    totalRows() {
      return this.items.length;
    },
  },

  methods: {
    emitirEditarItem(data) {
      this.$store.commit("PARAMETROS_PROJETO_ASTEC", data);
      this.$router.push('/astec/loteImportacao/registrosImportados/novoProjeto');
    },
  },
};
</script>

<style scoped>
.sortable-header {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.sort-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 5px;
}

</style>
